import Box from '@mui/material/Box'
import React from 'react'
import { Outlet } from 'react-router-dom'
import SentryNavigationTracker from '@/libs/sentry/SentryNavigationTracker'

export default function Layout(): JSX.Element {

  return (
    <Box display="flex" flexDirection="column" height="100%" component="footer">
      <SentryNavigationTracker />

      <Box display="flex" flexDirection="column" flex={1}>
        <Outlet />
      </Box>
    </Box>
  )
}
